import {v4 as uuid} from "uuid";
import {NodeFileSearchControl, LabelNumberTextControl} from "../../controls";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";
import Rete from "rete";
import {tempActionSocket} from "../../sockets";
import {SequenceComponent} from "../SequenceComponent";
import {ResourceType} from "models/ResourceType";

export class Image {

    constructor(parentComponent, imageAdded, imageRemoved) {
        this.parentComponent = parentComponent;
        this.onImageAdded = imageAdded;
        this.onImageRemoved = imageRemoved;
        this.isAdded = false;
    }

    addImage(node, imageUUID = null) {
        if (imageUUID == null) {
            imageUUID = uuid();
        }

        const imageFileControl = new NodeFileSearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getImageFileKey(imageUUID),
            node,
            ResourceType.NodeImage,
            false,
            "Image file"
        );

        const durationControl = new LabelNumberTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getImageDurationKey(imageUUID),
            node,
            false,
            "Duration"
        );

        const output = new Rete.Output(
            SequenceComponentHelper.getImageOutputKey(imageUUID),
            "Action",
            tempActionSocket,
            false
        );

        const removeImageControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getImageRemoveButtonKey(imageUUID),
            node,
            false,
            () => this.onRemoveImageClick.bind(this, node, imageUUID, removeImageControl, imageFileControl, durationControl, output)
        );

        node
            .addControl(removeImageControl)
            .addControl(imageFileControl)
            .addControl(durationControl)
            .addOutput(output)

        this.ImageAdded(node, imageUUID);
        node.update();
    }

    ImageAdded(node, addedImageUUID) {
        node.imageId = addedImageUUID;
        this.isAdded = true;
        this.onImageAdded();
    }

    onRemoveImageClick(node, imageUUID, removeImageControl, imageFileControl, durationControl, outputControl) {
        this.removeImage(node, imageUUID, removeImageControl, imageFileControl, durationControl, outputControl)
            .then(r => {
                this.imageRemoved(node, imageUUID);
            });
    }

    async removeImage(node, imageUUID, removeImageControl, imageFileControl, durationControl, outputControl) {
        node.removeControl(removeImageControl);
        node.removeControl(imageFileControl);
        node.removeControl(durationControl);

        outputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
        node.removeOutput(outputControl);

        node.update();

        this.parentComponent.editor.view.updateConnections({node});

        delete node.data[SequenceComponentHelper.getImageFileKey(imageUUID)];
        delete node.data[SequenceComponentHelper.getImageDurationKey(imageUUID)];
    }

    async imageRemoved(node, removedImageUUID) {
        node.imageId = null;
        this.isAdded = false;
        this.onImageRemoved();
    }

    handleAnswerAdded(node) {
        if (!this.isAdded) return;

        let imageOutputControl = null;
        node.outputs.forEach(output => {
            const outputKey = output.key.split('_');
            if (outputKey[1] === SequenceComponent.IMAGE_CHILD_COMPONENT_KEY) {
                if (imageOutputControl) throw new Error("Image component cannot handle multiple outputs.");
                imageOutputControl = output;
            }
        });

        if (imageOutputControl.connections.length > 0) {
            imageOutputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
            node.update();
            this.parentComponent.editor.view.updateConnections({node});
        }
    }

    handleAnswerRemoved(node) {
        if (!this.isAdded) return;
        node.update();
    }
}